const $window = $(window);
let windowWidth = $window.width();

// メディアクエリ
let mql = window.matchMedia('screen and (max-width: 1024px)');

// テスト
var _isTest = false;

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

// pageTop
import {pageTop} from "../include/module";
pageTop();

//showMovie
import {showMovie} from "../include/module";
showMovie();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();


$(window).on('load' , function() {

  if(_isTest) {

    //アニメーション省略
    $('#index-Loader').remove();
    mainAnime();

  } else {

    setTimeout(function(){$('#index-Loader').addClass("load");},200);
    setTimeout(function(){$('#index-Loader').addClass("hidden");},800);
    setTimeout(function(){$('#index-Loader').remove();},2000);
    setTimeout(function(){mainAnime();},800);

  }

  fogAnime();
  unitModal();
  scrollIndexAnime();

  setTimeout(function(){
    var $widget = $('iframe.twitter-timeline');
    var $widgetContents = $widget.contents();
    $widgetContents.find('.timeline-Body').css({"border-top":"none","border-bottom":"none"});
  },1000);

});

// ------------------------------------------------------------------------
// mainAnime
// ----- BOTH
// ------------------------------------------------------------------------
const mainAnime = () => {

  setTimeout(function(){$('.index-Keyvisual_Bg').addClass("is-animated");},0);
  setTimeout(function(){$('.index-Keyvisual_Tri').addClass("is-animated");},0);
  setTimeout(function(){$('.index-Keyvisual_Chara').addClass("is-animated");},0);
  setTimeout(function(){$('.index-Keyvisual_Logo').addClass("is-animated");},0);
};


// ------------------------------------------------------------------------
// fogAnime
// ----- BOTH
// ------------------------------------------------------------------------
const fogAnime = () => {

  VANTA.FOG({
    el: "#fog",
    mouseControls: true,
    touchControls: true,
    gyroControls: false,
    minHeight: 200.00,
    minWidth: 200.00,
    highlightColor: 0x8affe3,
    midtoneColor: 0xfffeaa,
    lowlightColor: 0xffffff,
    baseColor: 0x9eedff,
    blurFactor: 0.69,
    speed: 3,
    zoom: 0.50
  })

};

// ------------------------------------------------------------------------
// unitModal();
// ----- BOTH
// ------------------------------------------------------------------------
const unitModal = () => {

  const $modal = $('#Unit_Stage');
  const $modalClose = $('#Unit_Stage_Close');

  let scrollPosition;
  const ua = window.navigator.userAgent.toLowerCase();
  const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
  const body = document.querySelector('body');

  // 一覧から開く
  $(document).on('click', '[data-modal]', function(e) {
    e.preventDefault();
    var target = $(this).data('modal');
    modalOpen(target);
  });

  // 閉じるボタン
  $modalClose.on('click', function(e) {
      e.preventDefault();
      modalClose();
  });


  // モーダルを開く
  function modalOpen(target) {

    // モーダルが開いたら、bodyにfixedを付与
    // bodyFixedOn();

    // console.log(target);


    $('[data-modal-content = ' + target + ']').addClass('is-show');
    $modal.addClass('opened');

    // モーダルのスクロール位置上に
    scrollUnit();

  }

  // モーダルを閉じる
  function modalClose() {
    $('[data-modal-content]').removeClass('is-show');
    $modal.removeClass('opened');

    // モーダルが閉じられたら、スクロールのトップを取得してbodyに
    // bodyFixedOff();

  }

  //モーダルのスクロール一番上へ
  function scrollUnit() {

    $('#Unit_Stage,#Unit_Stage_Inner,.Unit_Stage_Profile').scrollTop(0);

  }

    //bodyのスクロール固定
    function bodyFixedOn() {
      if(isiOS){
          scrollPosition = window.pageYOffset;
          body.style.position = 'fixed';
          body.style.top = `-${scrollPosition}px`;
      }else {
          body.style.overflow = 'hidden';
      }
      // body.style.overflow = 'hidden';

  }

  function bodyFixedOff() {
      if(isiOS){
          body.style.removeProperty('position');
          body.style.removeProperty('top');
          window.scrollTo(0, scrollPosition);
      }else {
          body.style.removeProperty('overflow');
      }
      // body.style.removeProperty('overflow');
  }

};


// ------------------------------------------------------------------------
// scrollIndexAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollIndexAnime = () => {

  const controller = new ScrollMagic.Controller();

  //ページトップ出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'#index-Contents',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle('#st-Top', 'st-Top-Show')
  .addTo(controller);

  //　スクロールで発火系
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    const scene3 = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .99
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

  //　スクロールで発火系 背景
  const targetsBgPink = document.querySelectorAll(".js-scrollBg");
  const targetsBgPinkArray = Array.prototype.slice.call(targetsBgPink); //Array
  targetsBgPinkArray.forEach(targetsBgPink => {
    //シーンを作成
    new ScrollMagic.Scene({
        triggerElement: targetsBgPink,
        triggerHook: 1,
        duration:'100%'
    })
    .on("progress", function (prog) { // 使いたいシーンに対してprogressイベントを設定します
      var p = prog.progress; // 0～1の値が入ってきます
      anime({
        targets: targetsBgPink,
        translateY: (.2 * p) * -100 + "%",
        easing: 'easeOutSine',
        duration: 2000
      });
    })
    .addTo(controller);
  });


    //背景
    // new ScrollMagic.Scene({
    //   triggerElement: $(window).innerHeight(),
    //   triggerHook: 1,
    //   duration: $(window).innerHeight() * 10
    //   // duration: "200%"
    // })
    // .on("progress", function (prog) { // 使いたいシーンに対してprogressイベントを設定します
    //   var p = prog.progress; // 0～1の値が入ってきます
    //   anime({
    //     targets:"#index-Contents_Bg",
    //     backgroundPositionY: (.5 * p) * -100 + "%",
    //     easing: 'easeOutCubic',
    //     duration: 100,
    //     elasticity: 0
    //   });
    // })
    // .addTo(controller);

};



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js